<template>
    <div class="regulation-exemption-row">
        <BFormGroup
            :label="translate('Component(ResearchReviewProcess):exemption-name', 'Exemption')"
            class="mb-0"
        >
            <BFormInput
                :value="value.name"
                :placeholder="translate('Component(ResearchReviewProcess):exemption-name-placeholder', 'Enter exemption name')"
                @input="update('name', $event)"
            />
        </BFormGroup>
        <BFormGroup
            :label="translate('Component(ResearchReviewProcess):evidence', 'Evidence')"
            class="mb-0"
        >
            <BFormInput
                :value="value.evidence"
                :placeholder="translate('Component(ResearchReviewProcess):evidence-placeholder', 'Source text or page reference')"
                @input="update('evidence', $event || null)"
            />
        </BFormGroup>
        <BButton
            type="button"
            variant="flat-danger"
            class="btn-icon regulation-exemption-row__remove"
            :title="translate('Component(Button):remove', 'Remove')"
            @click="$emit('remove')"
        >
            <FeatherIcon icon="Trash2Icon" size="16" />
        </BButton>
    </div>
</template>

<script>
import {
    BButton,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue'

export default {
    name: 'RegulationExemptionRow',
    components: {
        BButton,
        BFormGroup,
        BFormInput,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        update(key, value) {
            this.$emit('input', {
                ...this.value,
                [key]: value,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.regulation-exemption-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    gap: .75rem;
    align-items: end;
    padding: .75rem;
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
}

.regulation-exemption-row__remove {
    margin-bottom: .15rem;
}

@media (max-width: 767.98px) {
    .regulation-exemption-row {
        grid-template-columns: 1fr auto;
    }

    .regulation-exemption-row > :first-child,
    .regulation-exemption-row > :nth-child(2) {
        grid-column: 1 / -1;
    }
}
</style>
